import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bell, Ellipsis } from "lucide-react";

export default function ExpHeader({ title, onBell, onMore, testid }) {
  const navigate = useNavigate();
  return (
    <header style={H.bar} data-testid={testid || "exp-header"}>
      <button style={H.btn} aria-label="Retour" data-testid="exp-back-btn" onClick={() => navigate(-1)}>
        <ArrowLeft size={21} strokeWidth={2.4} />
      </button>
      <h1 style={H.title}>{title}</h1>
      <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
        <button style={H.btn} aria-label="Notifications" data-testid="exp-bell-btn" onClick={onBell}>
          <Bell size={19} strokeWidth={2.2} />
        </button>
        <button style={H.btn} aria-label="Plus d'options" data-testid="exp-more-btn" onClick={onMore}>
          <Ellipsis size={20} strokeWidth={2.4} />
        </button>
      </div>
    </header>
  );
}

const H = {
  bar: { position: "sticky", top: 0, zIndex: 40, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 10px 8px", background: "rgba(4,18,11,0.94)", backdropFilter: "blur(14px)" },
  btn: { background: "none", border: "none", color: "#ECF5EE", cursor: "pointer", padding: 6, display: "flex" },
  title: { margin: 0, fontSize: 16.5, fontWeight: 800, color: "#FFFFFF", letterSpacing: 0.2 },
};
